export default __webpack_public_path__ + "static/media/HST-DirectorLite.a948de6d.svg";